import React, { useEffect } from "react";
import { LinkedInCallback } from "react-linkedin-login-oauth2";
import { Navigate, createBrowserRouter, useNavigate } from "react-router-dom";
import HomePage from "../../modules/home/page/HomePage";
import ChatMessagingPage from "../../modules/messaging/page/ChatMessagingPage";
import AppMainContainer from "../components/general/AppMainContainer";
import { useTSData } from "../components/general/TSDataContext";
import SpinnerUi from "../components/ui/SpinnerUI";
import TSNetworkErrorPage from "../components/ui/TSNetworkErrorPage";
import TSNotFoundErrorPage from "../components/ui/TSNotFoundErrorPage";
import TSServeurErrorPage from "../components/ui/TSServeurErrorPage";
import { ERROR_MODE, PUBLIC_MODE } from "../constants/generalConstants";
import {
  ASSISTANT_BOT_PAGE_ROUTE,
  HOME_PAGE_ROUTE,
  MESSAGING_PAGE_ROUTE,
  MFA_SETTINGS_PAGE_ROUTE,
  MFA_VERIFY_PAGE_ROUTE,
  NETWORK_ERROR_PAGE_ROUTE,
  NOT_FOUND_ERROR_PAGE_ROUTE,
  REGISTER_PAGE_ROUTE,
  SERVER_ERROR_PAGE_ROUTE,
} from "../constants/routerConstants";
import AssistantBotPage from "../../modules/assistant/page/AssistantBotPage";
import RegisterPage from "../../modules/auth/page/RegisterPage";
import MfaVerifyPage from "../../modules/auth/page/MfaVerifyPage";
import MfaSettingsPage from "../../modules/auth/page/MfaSettingsPage";

const ErrorPageContainer = ({ children }) => {
  const navigate = useNavigate();
  const { setMode } = useTSData();
  useEffect(() => { setMode(ERROR_MODE); }, []);
  const retourHandler = () => navigate(-1);
  return React.cloneElement(children, { onRetour: retourHandler });
};

const AssistantPageContainer = ({ children }) => {
  return window.self !== window.top && children;
};

const MessagingPageContainer = ({ children }) => {
  return window.self === window.top && <SpinnerUi>{children}</SpinnerUi>;
};

const NonMessagingPageContainer = ({ children }) => {
  const { setMode } = useTSData();
  useEffect(() => { setMode(PUBLIC_MODE); }, []);
  return window.self === window.top && <SpinnerUi>{children}</SpinnerUi>;
};

const router = createBrowserRouter([
  { path: "*", element: <Navigate to={NOT_FOUND_ERROR_PAGE_ROUTE} replace /> },

  { path: "/linkedin", element: <LinkedInCallback />, exact: true },

  {
    path: "/",
    element: <AppMainContainer />,
    exact: true,
    children: [
      { path: SERVER_ERROR_PAGE_ROUTE,    element: <ErrorPageContainer><TSServeurErrorPage /></ErrorPageContainer>,  exact: true },
      { path: NOT_FOUND_ERROR_PAGE_ROUTE, element: <ErrorPageContainer><TSNotFoundErrorPage /></ErrorPageContainer>, exact: true },
      { path: "/auth/callback",           element: <ErrorPageContainer><TSNotFoundErrorPage /></ErrorPageContainer>, exact: true },
      { path: NETWORK_ERROR_PAGE_ROUTE,   element: <ErrorPageContainer><TSNetworkErrorPage /></ErrorPageContainer>,  exact: true },

      {
        path: HOME_PAGE_ROUTE,
        element: <NonMessagingPageContainer><HomePage /></NonMessagingPageContainer>,
        exact: true,
      },
      {
        path: MESSAGING_PAGE_ROUTE,
        element: <MessagingPageContainer><ChatMessagingPage /></MessagingPageContainer>,
        exact: true,
      },
      {
        path: ASSISTANT_BOT_PAGE_ROUTE,
        element: <AssistantPageContainer><AssistantBotPage /></AssistantPageContainer>,
        exact: true,
      },
      {
        path: REGISTER_PAGE_ROUTE,
        element: <NonMessagingPageContainer><RegisterPage /></NonMessagingPageContainer>,
        exact: true,
      },
      // Step 2 of login when MFA is enabled
      {
        path: MFA_VERIFY_PAGE_ROUTE,
        element: <NonMessagingPageContainer><MfaVerifyPage /></NonMessagingPageContainer>,
        exact: true,
      },
      // MFA settings — accessible from profile menu (basic accounts only)
      {
        path: MFA_SETTINGS_PAGE_ROUTE,
        element: <NonMessagingPageContainer><MfaSettingsPage /></NonMessagingPageContainer>,
        exact: true,
      },
    ],
  },
]);

export default router;
